import { FC, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";


import ExpiredReports from "../../../pages/userReports/expiredReports/expiredReports";
import CircleLoader from "../../../components/custom/circleLoader/circleLoader";
import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const ExpiredReportsSection: FC = () => {
  const { expiredReportsCount } = useSelector(
    (state: any) => state.userReports.expiredReports
  );

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const { claims } = useSelector((state: any) => state.user.user.data);
  const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
  const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

  const buttonsContainerRef = useRef<HTMLDivElement>(null);
  const headFilterRef = useRef<any>(null);

  const sidebarWidth = isOpenSidebar ? 190 : 44;
  const headerFiltersAndSelectWidth = 525;
  const minEmptyWidthForNewBtn = 300;
  const groupBtnWidth = 70;
  const buttonWidth = 130;

  const availableButtons = [
    {
      component: (
        <HeaderBtn
          content="Настройки"
          purpose="expiredReportsSettings"
          modalTitle="Настройки"
        />
      ),
    },

    (claims.includes("admin") || claims.includes("reports:expired:export")) && {
      component: (
        <HeaderBtn
          content="Выгрузить список"
          purpose="unloadExpiredList"
          modalTitle="Выгрузить список"
          hasIcon="excel"
        />
      ),
    },

    (claims.includes("admin") || claims.includes("reports:expired:delete")) && {
      component: (
        <HeaderBtn
          content="Удалить"
          purpose="deleteExpired"
          modalTitle="Удалить отчеты"
        />
      ),
    },
    (claims.includes("admin") || claims.includes("reports:expired:create")) && {
      component: (
        <HeaderBtn
          content="Создать отчеты"
          purpose="createExpiredReports"
          modalTitle="Создать отчеты"
        />
      ),
    },
  ];

  const filteredAvailableButtons = availableButtons.filter(
    (btn: { component: JSX.Element }) => btn
  );

  useEffect(() => {
    if (
      filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
      filteredAvailableButtons.length
    ) {
      setOverflowedBtnsCount(0);
    }
  }, [filteredAvailableButtons, overflowedBtnsCount]);

  const handleWindowResize = useCallback(() => {
    const allButtonsWidth =
      filteredAvailableButtons.slice(
        0,
        filteredAvailableButtons.length - overflowedBtnsCount
      ).length * buttonWidth;
    const spaceToLeftSideOfFilters =
      headFilterRef.current?.getBoundingClientRect().left;
    const windowWidth = window.innerWidth;
    const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
      : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

    if (isOverflowed) {
      setIsOpenGroupBtn(true);
      setOverflowedBtnsCount((prevValue: number) => {
        if (overflowedBtnsCount === filteredAvailableButtons.length) {
          return prevValue;
        } else {
          return overflowedBtnsCount + 1;
        }
      });
    }
    const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? spaceToLeftSideOfFilters -
          sidebarWidth -
          allButtonsWidth +
          groupBtnWidth >
        minEmptyWidthForNewBtn
      : spaceToLeftSideOfFilters - allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
    if (isEnoughtSpace) {
      setOverflowedBtnsCount((prevValue: number) => {
        if (prevValue <= 1) {
          setIsOpenGroupBtn(false);
          return 0;
        } else return prevValue - 1;
      });
    }
  }, [
    filteredAvailableButtons,
    overflowedBtnsCount,
    sidebarWidth,
    headerFiltersAndSelectWidth,
  ]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        availableButtons={displayedAvailableBtns}
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        section="Отчеты"
        title="Не сданы"
      >
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") || claims.includes("reports:view")) && (
              <Link to="/reports" className="tab">
                <div className="buttons__btn">Всего</div>
              </Link>
            )}
            <Link to="/reports/expired" className="tab">
              <div className="buttons__btn --active">
                Не сданы
                <div className="tab__reports_count">
                  {!expiredReportsCount && expiredReportsCount !== 0 ? (
                    <CircleLoader />
                  ) : (
                    expiredReportsCount
                  )}
                </div>
              </div>
            </Link>
          </div>
          <ExpiredReports />
        </div>
      </SectionContent>
    </div>
  );
};

export default ExpiredReportsSection;
